import _objectSpread from "@babel/runtime/helpers/esm/objectSpread2";
import _classCallCheck from "@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "@babel/runtime/helpers/esm/createClass";
import _inherits from "@babel/runtime/helpers/esm/inherits";
import _createSuper from "@babel/runtime/helpers/esm/createSuper";
import React, { Component } from 'react';
import { SVGIcon } from '@instructure/ui-svg-images';

var _ref = /*#__PURE__*/React.createElement("path", {
  d: "M960,1807.05882 C492.875294,1807.05882 112.941176,1427.12471 112.941176,960 C112.941176,492.875294 492.875294,112.941176 960,112.941176 C1427.12471,112.941176 1807.05882,492.875294 1807.05882,960 C1807.05882,1427.12471 1427.12471,1807.05882 960,1807.05882 M960,0 C430.644706,0 0,430.644706 0,960 C0,1489.35529 430.644706,1920 960,1920 C1489.35529,1920 1920,1489.35529 1920,960 C1920,430.644706 1489.35529,0 960,0 M1016.47059,1275.44471 L1016.47059,451.764706 L903.529412,451.764706 L903.529412,1275.44471 L604.687059,976.602353 L524.724706,1056.45176 L960,1491.61412 L1395.27529,1056.45176 L1315.31294,976.602353 L1016.47059,1275.44471 Z",
  fillRule: "evenodd",
  stroke: "none",
  strokeWidth: "1"
});

var IconDropDownLine = /*#__PURE__*/function (_Component) {
  _inherits(IconDropDownLine, _Component);

  var _super = _createSuper(IconDropDownLine);

  function IconDropDownLine() {
    _classCallCheck(this, IconDropDownLine);

    return _super.apply(this, arguments);
  }

  _createClass(IconDropDownLine, [{
    key: "render",
    value: function render() {
      return /*#__PURE__*/React.createElement(SVGIcon, Object.assign({}, this.props, {
        name: "IconDropDown",
        viewBox: "0 0 1920 1920"
      }), _ref);
    }
  }]);

  IconDropDownLine.displayName = "IconDropDownLine";
  return IconDropDownLine;
}(Component);

IconDropDownLine.glyphName = 'drop-down';
IconDropDownLine.variant = 'Line';
IconDropDownLine.propTypes = _objectSpread({}, SVGIcon.propTypes);
export default IconDropDownLine;
export { IconDropDownLine };